import * as React from "react";
import { TTranslate } from "../../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import ApplicantRequestForm from "./ApplicantRequestForm";
import { IRequest } from "../../../../model/request/Request";

export interface State {}

export interface UpdateApplicantRequestFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  codebooks: any[];
  rowData: IRequest;
}

class UpdateApplicantRequestForm extends React.Component<
  UpdateApplicantRequestFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler, rowData } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let updateRequest;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          updateRequest = values;
          updateRequest.id = rowData.id;
          updateRequest.reportingPeriodApplicantId= parseInt(values.reportingPeriodApplicantId, 10);
        }
      });
      return updateRequest;
    });
  }

  render() {
    const { translate, codebooks, rowData } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <ApplicantRequestForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        codebooks={codebooks}
        rowData={rowData}
      />
    );
  }
}

export default UpdateApplicantRequestForm;
